module.exports = __webpack_public_path__ + "img/promo-swift-octure-2022.9b2ea2c1.jpg";